import {useUser} from "../../../Context/UserContext";
import ResultView from "../../V2/ResultView";
import {MessageCodes} from "../MessageCodes";
import ResultTable from "../../Table/ResultTable";
import HecRasHelper from "../../../Helpers/HecRasHelper";
import ResultHeader from "../../Table/ResultHeader";
import ResultRow from "../../Table/ResultRow";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import ResultBody from "../../Table/ResultBody";
import ResultBodyCell from "../../Table/ResultBodyCell";
import CheckCSName from "../../CheckCSName";
import ResultCellHighlight from "../../Table/ResultCellHighlight";
import ResultText from "../ResultText";

export default function SV7({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

function Description({row, settings, globalVariables}) {
    switch (row.error_id) {
        case MessageCodes.Internal.SV7_SV07.error_id: {
            return (
                <ResultText>
                    The stream centerline is not between the (TOBL/TOBR) survey points around the following {row?.data?.length} cross sections:
                    <br/>
                    <CheckCSName csNameList={row?.data?.map(x => x?.cross_section)} />
                </ResultText>
            )
        }
    }
}